import { AccountsManager } from '../components/AccountsManager';

/**
 * Contas em Teste — contas virtuais na fase de avaliação (TEST), divididas
 * por mercado (B3 | Forex). Cada card tem busca própria e abre o mesmo drawer
 * de inspeção/ações. Dados via GET /admin/accounts?phase=TEST (M3).
 */
export function AccountsTestingPage() {
  return (
    <div className="space-y-6">
      <div>
        <p className="text-2xs text-brand-500 font-semibold uppercase tracking-widest">Operação</p>
        <h1 className="font-display text-ink-900 mt-1 text-3xl font-semibold tracking-tight">
          Contas em Teste
        </h1>
        <p className="text-ink-500 mt-1 text-sm">
          Traders na fase de avaliação — viram Funded ao bater a meta sem estourar o drawdown.
        </p>
      </div>

      <div className="grid gap-6 xl:grid-cols-2">
        <AccountsManager variant="testing" marketCode="B3" />
        <AccountsManager variant="testing" marketCode="FOREX" />
      </div>
    </div>
  );
}
